import { navigationService } from '@/Core/Services/NavigationService'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

/**
 * Хук для ініціалізації NavigationService з React Router navigate
 *
 * Повинен викликатися один раз в кореневому Layout компоненті після ініціалізації Kernel
 *
 * @example
 * ```tsx
 * function RootLayout() {
 *   useInitializeNavigation()
 *   return <Outlet />
 * }
 * ```
 */
export function useInitializeNavigation(): void {
    const navigate = useNavigate()

    useEffect(() => {
        navigationService.initialize(navigate)
    }, [navigate])
}
